import React from 'react';

import {
  Paper,
  Table,
  TableHead,
  TableRow as TableRowUI,
  TableCell,
  TableBody,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import * as S from './styles';
import { TableRow } from './components';

export default function MinimizableTable({ cells, data, beforeCells }) {
  return (
    <S.Wrapper component={Paper}>
      <Table stickyHeader>
        <TableHead>
          {!isEmpty(beforeCells) && (
            <TableRowUI>
              {beforeCells.map((cell, index) => (
                <TableCell
                  key={index}
                  colSpan={cell.cols}
                  align="center"
                  variant="head"
                >
                  {cell.label}
                </TableCell>
              ))}
            </TableRowUI>
          )}
          <TableRowUI>
            <TableCell />
            {cells.map((cell, index) => (
              <TableCell key={index}>{cell.label}</TableCell>
            ))}
          </TableRowUI>
        </TableHead>
        <TableBody>
          {data.map((i) => (
            <TableRow
              cells={cells.map((cell) => cell.id)}
              data={i}
              heading={cells}
            />
          ))}
        </TableBody>
      </Table>
    </S.Wrapper>
  );
}

MinimizableTable.propTypes = {
  beforeCells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      cols: PropTypes.number.isRequired,
    })
  ),
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
};

MinimizableTable.defaultProps = {
  beforeCells: [],
};
